// extracted by mini-css-extract-plugin
export var dividerContainer = "_9q-0";
export var line = "_9q-1";